import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import {
  Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper,
  IconButton, Typography, CircularProgress, Box,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

function FuncionarioList({ refresh, onEdit, onDeleted }) {
  const [funcionarios, setFuncionarios] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchFuncionarios = useCallback(() => {
    setLoading(true);
    api.get('/funcionarios')
      .then((response) => setFuncionarios(response.data.data || []))
      .catch((err) => console.error('Erro ao buscar funcionários:', err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchFuncionarios();
  }, [fetchFuncionarios, refresh]);

  const handleDelete = (id) => {
    if (!window.confirm('Tem certeza que deseja remover este funcionário?')) return;
    api.delete('/funcionarios/' + id)
      .then(() => {
        if (onDeleted) onDeleted();
        fetchFuncionarios();
      })
      .catch((err) => console.error('Erro ao deletar funcionário:', err));
  };

  const formatDate = (val) => {
    if (!val) return '-';
    return String(val).substring(0, 10).split('-').reverse().join('/');
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ mt: 3 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Funcionário</TableCell>
            <TableCell>Cargo</TableCell>
            <TableCell>CBO</TableCell>
            <TableCell>Depto</TableCell>
            <TableCell>Admissão</TableCell>
            <TableCell align="right">Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {funcionarios.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} align="center">
                <Typography color="text.secondary">Nenhum funcionário cadastrado.</Typography>
              </TableCell>
            </TableRow>
          ) : (
            funcionarios.map((f) => (
              <TableRow key={f.id}>
                <TableCell>{f.pessoa_nome || '-'}</TableCell>
                <TableCell>{f.cargo || '-'}</TableCell>
                <TableCell>{f.cbo || '-'}</TableCell>
                <TableCell>{f.departamento || '-'}</TableCell>
                <TableCell>{formatDate(f.data_admissao)}</TableCell>
                <TableCell align="right">
                  <IconButton size="small" onClick={() => onEdit(f)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton size="small" onClick={() => handleDelete(f.id)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default FuncionarioList;
